import React, { useState, useEffect } from 'react';
import CloseButton from '../../../../sharecomponents/CloseButton';
import Post from '../../../../../utils/Post';
import VainillaDialog from '../../../../sharecomponents/vanilladialog';
import Verifiers from '../../../../../utils/Verifiers.jsx';

/**
 * 
 * @param {object} FB_editor objeto que contiene el formato para determinar las relaciones esntre una flor y sus blancos biologicos, debe tener 
 * el siguiente formato: {flor:int > 0, blancos_biologicos:{int > 0:int > 0}} si no se envia se toma como un nuevo registro
 * @param {List} flores Lista de flores a mostrar debe tener el formato {id:int > 0, nombre:string} 
 * @param {List} blancos_biologicos Lista de blancos biologicos a mostrar debe tener el formato {id:int > 0, nombre:string}
 * @returns 
 */
const AgregarRelacionesFlorBB = (p) => {
    //nomenclatura para abreviar utilizada: FB = flor-blanco biologico, BB = blanco biologico
    const update = p.FB_editor ? true : false;
    const close = p.close ?? (() => { });
    const title = p.title ?? '';
    const [loader, setloader] = useState(false);
    const ldr = (<div className='vw-100 vh-100 top-left-front bg-white3 blur-s'><div className='loader' /></div>);
    const [dialog, setdialog] = useState({ show: false })
    const flores = p.flores ?? [];
    const blancos_biologicos = p.blancos_biologicos ?? [];
    const [FB_editor, setFB_editor] = useState({ flor: 0, blancos_biologicos: {} });
    const BBselectedClass = 'btn btn-warning border border-dark shadow-sm text-bold round-xxl';
    const BBnoSelectedClass = 'btn btn-light border border-dark text-bold opacity-70 shadow round-xxl';
    useEffect(() => {
        if (update) setFB_editor({ ...p.FB_editor });

    }, [p.FB_editor, p.flores]);

    const APISend = async () => {
        let data = { flor: FB_editor.flor, blancos_biologicos: Object.keys(FB_editor.blancos_biologicos) };
        console.log(`data`, data);
        let resp = await Post(`/mipe/relacion/flor/blanco_biologico/add`, { ...data }, 'POST', setloader);
        if (!resp.estatus) {
            Verifiers.activeDialog(setdialog, resp.msj, 'Error', 'error');
            return;
        }
        close(resp.data);
    }

    const change = (e) => setFB_editor({ ...FB_editor, [e.target.name]: e.target.value })

    return (
        <div className='vw-100 vh-100 blur-l dosis p-1 dosis' style={{ zIndex: 999, top: 0, left: 0, position: "fixed" }}>
            <CloseButton close={() => close(false)} />
            <div className='row justify-content-evenly w-100 m-0 p-0'>
                <div className='col-auto p-1 ps-3 pe-3 round-xxl bg-white shadow h4 text-300'>{title} <span className='text-m text-bold ms-2'>{update ? 'Actualizar' : 'Nuevo'}</span> </div>
                <div className='w-100 m-0 p-0' />
                <div className='bw-1200 bg-white shadow-multi round-m p-2 mt-2 mb-5'>
                    <div className='row justify-content-evenly w-100 m-0 p-0'>
                        <div className='bw-400 mt-2'>
                            <label className='text-bold text-s w-100 ps-3'>{update ? "Actualizando esta flor" : "Seleccione la flor"}</label>
                            <select className='form-control form-control-sm shadow round-m' value={FB_editor.flor} name='flor' onChange={change} disabled={update}>
                                {!update && <option value='0' >SELECCIONE UNA OPCIÓN</option>}
                                {flores.map((flor, index) => <option key={index} value={flor.id}>{(flor?.nombre ?? '').toUpperCase()}</option>)}
                            </select>
                        </div>
                        <div className='w-100 m-0 p-0 mt-3 text-center text-bold'>Seleccione los blancos biológicos a los que esta flor es suseptible</div>
                        <div className='w-70 m-0 p-0 border-bottom' />
                        <div className='w-100 m-0 p-0 mb-2' />
                        {blancos_biologicos.map((blanco, index) =>
                            <div key={index} className='col-auto m-1'>
                                <button className={FB_editor.blancos_biologicos[blanco.id] ? BBselectedClass : BBnoSelectedClass}
                                    onClick={() => {
                                        let bbs = FB_editor.blancos_biologicos;
                                        if (bbs[blanco.id]) delete bbs[blanco.id];
                                        else bbs[blanco.id] = blanco.id;
                                        setFB_editor({ ...FB_editor, blancos_biologicos: bbs });
                                    }}
                                >{blanco.nombre}</button>
                            </div>
                        )}
                        <div className='w-100 m-0 p-0 mb-3' />
                        <button className='btn btn-warning bw-400 shadow round-xxl text-bold'
                            disabled={!update && (Object.keys(FB_editor.blancos_biologicos).length === 0 || FB_editor.flor === 0)}
                            onClick={APISend}
                        >{update ? "Guardar cambios" : "generar registro"}</button>
                        <div className='w-100 m-0 p-0 mb-5' />
                    </div>
                </div>
            </div>
            {loader && ldr}
            <VainillaDialog data={dialog} />
        </div>
    )
}

export default AgregarRelacionesFlorBB;